import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AddCurrencyBook } from './AddCurrencyBook';
import CurrencyBook from './CurrencyBook';
import { useGetCurrencyBooksQuery } from './GetCurrencyBooks.generated';

const CurrencyBooks = () => {
  const { path } = useRouteMatch();

  const [result] = useGetCurrencyBooksQuery();

  const currency_books = result.data?.currency_books;

  return (
    <div className="relative flex flex-col w-full md:flex-row">
      <Switch>
        <Route exact path={`${path}/`} />
        <Route exact path={`${path}/new`}>
          <AddCurrencyBook />
        </Route>
        {currency_books?.map((currency_book) => (
          <Route path={`${path}/${currency_book?.id}`} key={currency_book?.id}>
            <CurrencyBook id={currency_book.id} />
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default CurrencyBooks;
